module.exports = __webpack_public_path__ + "static/HTH1-d4d4a4e856c7496bb980f03950053053.png";